var _style, _path, _line, _line2, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamingPlatformSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#49e1ca;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#49e1ca;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,23.5v-15C24,7.1,22.9,6,21.5,6H10.5C9.1,6,8,7.1,8,8.5v15c0,1.4,1.1,2.5,2.5,2.5h10.9 C22.9,26,24,24.9,24,23.5z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 12.9,
    y1: 20.3,
    x2: 12.9,
    y2: 23.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 14.5,
    y1: 21.8,
    x2: 11.4,
    y2: 21.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1,22.8c0-0.6-0.5-1-1-1c-0.6,0-1,0.5-1,1s0.5,1,1,1C20.6,23.9,21.1,23.4,21.1,22.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18,19.8c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1s1-0.5,1-1C19,20.2,18.6,19.8,18,19.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.4,17.7h9.1c0.3,0,0.5-0.2,0.5-0.5V9.4c0-0.3-0.2-0.5-0.5-0.5h-9.1c-0.3,0-0.5,0.2-0.5,0.5v7.8 C10.9,17.5,11.1,17.7,11.4,17.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamingPlatformSelected);
export default __webpack_public_path__ + "static/media/gamingPlatformSelected.9f247ac9051780180191907fb3b034db.svg";
export { ForwardRef as ReactComponent };